//🚨🚨todo:: find a better way, it loads it to the dom
@import "~swiper/swiper";
@import "~swiper/modules/pagination/pagination";
@import "~swiper/modules/navigation/navigation";

.s-slider-wrapper {
  &-container{

  }
  &-thumbs{
    &-container{

    }
  }
  &-button-next{
    svg{

    }
  }
  &-button-prev{
    svg{

    }
  }
}
